export default {
  isLoggedIn: state => !!state.user,
  getUser: state => state.user,
  getFullUser: state =>
    state.user && state.user.firstName + " " + state.user.lastName,
  getToken: state => state.userToken,
  getRoles: state => (state.user && state.user.Roles) || []
};
